import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophyStar } from '@fortawesome/pro-duotone-svg-icons';
import SpecialtyLicense from "../assets/images/specialty_license.svg";
import HigherEdCash from "../assets/images/higher_ed_cash.svg";
import StateRevEx from "../assets/images/state_rvex.svg";
import HigherEd from "../assets/images/higher_ed.svg";
import BreadCrumbs from './BreadCrumbs';
import FeatureNav from './FeatureNav';
import FooterSection from './FooterSection';
import HeaderComponent from './HeaderComponent';
import '../assets/styles/main.css';

const PopularTools = () => {
  return (
    <div className="popular-tools" id="popular-tools">
      <HeaderComponent />
      <FeatureNav />
      <BreadCrumbs />
      <main className="mt-20" aria-label="main-heading">
        <div className="text-center mb-4">
          <h1 className="display-5 fw-bold mb-4">Popular Tools</h1>
        </div>
        <div className="jumbotron border text-light rounded my-4 mx-4 pt-3 pb-0 border shadow px-0" style={{ backgroundColor: "var(--tu-teal)" }}>
          <div className="col-12 py-2 rounded" style={{ paddingLeft: "15px" }}>
            <h3 className="text-light">
              <FontAwesomeIcon icon={faTrophyStar} className="me-2" />
              Popular Tools
            </h3>
            <p className="lead">Explore the most popular tools on Transparent Utah</p>
          </div>

          <section className="col-12 bg-light">
            <div className="row justify-content-center px-3">
              <article className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank"
                  rel="noopener noreferrer" href="https://transparent.utah.gov/specialty-license-report/" title="Specialty License Plates">
                  <div className="card-header text-center text-white px-0" style={{ backgroundColor: "var(--tu-teal)" }}>Specialty License Plates <sup><span
                    className="badge badge-info">New</span></sup></div>
                  <img className="card-img-top" alt="Specialty License Plates" src={SpecialtyLicense}
                    data-holder-rendered=" true" />
                  <div className="card-body py-0">
                    <p className="card-text text-center">Learn about changes in license plate trends over the last 5 years with an animated visualization</p>
                  </div>
                </a>
              </article>

              <article className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank"
                  rel="noopener noreferrer" href="https://transparent.utah.gov//he-cash/" title="Higher Education">
                  <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Higher Education - Cash <sup><span
                    className="badge badge-info">New</span></sup></div>
                  <img className="card-img-top" alt="Higher Education - Cash" src={HigherEdCash}
                    data-holder-rendered=" true" />
                  <div className="card-body py-0">
                    <p className="card-text text-center">View Cash, Cash Equivalents, and Cash Flows in Higher Education </p>
                  </div>
                </a>
              </article>

              <article className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank"
                  rel="noopener noreferrer" href="https://old.transparent.utah.gov/state_rvex.php" title="State Revenue & Expenditure">
                  <div className="card-header text-center text-white px-0" style={{ backgroundColor: "var(--tu-teal)" }}>State Revenues & Expenditures <sup><span
                    className="badge badge-info">New</span></sup></div>
                  <img className="card-img-top" alt="State Revenues & Expenditures" src={StateRevEx}
                    data-holder-rendered=" true" />
                  <div className="card-body py-0">
                    <p className="card-text text-center">Take a 20 year deep-dive into the Revenues and Expenditures for which
                      the
                      state is financially accountable. </p>
                  </div>
                </a>
              </article>

              <article className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank"
                  rel="noopener noreferrer" href="https://transparent.utah.gov/higher-education/higher-education-expenditure" title="Higher Education">
                  <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Higher Education Expenditure <sup><span
                    className="badge badge-info">New</span></sup></div>
                  <img className="card-img-top" alt="Higher Education Expenditure" src={HigherEd}
                    data-holder-rendered=" true" />
                  <div className="card-body py-0">
                    <p className="card-text text-center">Explore how public funds are appropriated in Utah's Higher Education
                      System </p>
                  </div>
                </a>
              </article>
            </div>
          </section>
        </div>
      </main>
      <FooterSection />
    </div>
  )
}

export default PopularTools;